// Keeps track of necessary connections, etc
export class Diagnostics {
  constructor(){
    window.addEventListener('online',  this.getOnlineStatus)
    window.addEventListener('offline',  this.getOnlineStatus)
  }

  getOnlineStatus(){
    this.status = window.navigator.onLine? 'online' : 'offline'
    return this.status
  }
}
